<template>
  <div class="h--100">
    <v-login :title="title">
      <template v-if="!resetPwd">
        <form
          action
          @submit.prevent="handleLogin"
        >
          <v-fieldset
            id="username"
            v-model="credentials.username"
            text="User Name"
            placeholder="e.g. john.smith@nata.com.au"
            type="email"
            is-required
          />
          <v-fieldset
            id="password"
            v-model="credentials.password"
            text="Password"
            placeholder="Must have at least 6 characters"
            help-text=""
            type="password"
            pattern=".{6,}"
            is-required
          />
          <v-button
            class="mt-auto"
            is-submit
            size="lg"
            is-block
          >
            Log In
          </v-button>
        </form>
        <p class="text--sm text--center">
          Forgot your password?
          <a
            href="#"
            @click="switchToResetPwd"
          >Click here to reset your password</a>
        </p>
        <p class="text--primary text--center">
          <a
            :href="getRegistrationFormLink()"
          >
            Request
            Registration
            form
          </a>
          <span class="text--padded"> | </span>
          <a
            href="#"
            @click="showTerms"
          >Terms and Conditions</a>
        </p>
      </template>
      <template v-if="resetPwd">
        <p class="text--primary">
          Please enter your email address and we will send you instructions to change your password.
        </p>
        <v-fieldset
          id="email"
          v-model="email"
          text="Email Address"
          type="email"
          is-required
          :help-text="emailError"
        />
        <v-button
          class="mt-auto"
          size="lg"
          is-block
          @click="handleResetPwd"
        >
          Send Instructions
        </v-button>
        <v-button
          color="transparent"
          is-block
          @click="switchToLogin"
        >
          Back to Login
        </v-button>
      </template>
    </v-login>
    <v-modal
      v-if="showModal"
      @close="showModal = false"
    >
      <template #header>
        {{ ModalTitle }}
      </template>
      <span v-html="ModalBody" />
      <template #footer>
        <v-button-group is-right>
          <v-button
            color="secondary"
            size="lg"
            has-min-width
            @click="showModal = false"
          >
            Ok
          </v-button>
        </v-button-group>
      </template>
    </v-modal>
  </div>
</template>
<script>
  import Login from "@/templates/Login";
  import Button from "@/atoms/Button";
  import Modal from "@/atoms/Modal";
  import Fieldset from "@/molecules/Fieldset";
  import TokenService from "../common/tokenService";
  import constants from "@/common/constants";
  import htmlConstants from "@/common/htmlConstants";
  import routes from "@/common/routes";
  import {LOGIN} from "@/store/actions.type";
  import {REQUEST_RESET_PASSWORD_EMAIL} from "../store/actions.type";

  export default {
    name: "Login",
    components: {
      "v-login": Login,
      "v-fieldset": Fieldset,
      "v-button": Button,
      "v-modal": Modal
    },
    data() {
      return {
        credentials: {
          username: null,
          password: null
        },
        email: '',
        resetPwd: false,
        title: 'Log In',
        emailError: '',
        showModal: false,
        ModalTitle: '',
        ModalBody: ''
      };
    },
    watch: {
      email: {
        handler: function (val) {
          this.validate();
        }
      }
    },
    methods: {
      handleLogin() {
        this.credentials.rememberMe = TokenService.getRememberMeCookie(this.credentials.username);
        this.$store.dispatch(LOGIN, this.credentials).then((res) => {
          TokenService.setToken(
            this.$store.state.auth.token,
            this.$store.state.auth.permissions
          );

          if (!this.$store.state.auth.twoFactorAuth.isValidRememberMe && (
            this.$store.state.auth.twoFactorAuth.tf_type === "email" ||
            this.$store.state.auth.twoFactorAuth.tf_remind_user)
          ) {

            this.$router.push(routes.TWO_FACTOR);
          } else {
            // 2fa is not configured; but user has opted not to remind. so no need to prompt.
            // set the token (authentication token) and navigate to /dashboard
            if (localStorage.getItem(constants.CURRENT_ROLE) === constants.NATA_ROLE_ADMIN) {
              this.$router.push(routes.ADMIN.OUTSTANDING_ACTIVITIES);
            } else {
              this.$router.push(routes.DASHBOARD);
            }
          }
        });
      },
      handleResetPwd() {
        this.validate();
        if (this.emailError.length === 0) {
          //Note that this will never return an error to prevent hacker guessing email addresses to find valid accounts
          this.$store.dispatch(REQUEST_RESET_PASSWORD_EMAIL, this.email).then(response => {
            this.$notify({
              title: 'Success',
              text: response.data,
              type: 'success'
            });
            this.email = '';
            this.switchToLogin();
          });
        }
      },
      switchToResetPwd() {
        this.title = 'Forgot Your Password?';
        this.resetPwd = true;
      },
      switchToLogin() {
        this.title = 'Login';
        this.resetPwd = false;
      },
      validate() {
        const checkField = document.getElementById('email');
        const isValid = checkField.checkValidity();
        if (!isValid) {
          this.emailError = 'Please input valid detail for email';
        } else {
          this.emailError = '';
        }
      },
      getRegistrationFormLink() {
        return 'mailto:'+constants.NATA_CONTACTS.EMAIL+'?subject=Request Registration form from NATA';
      },
      showTerms() {
        this.showModal = true;
        this.ModalTitle = 'Terms and Conditions';
        this.ModalBody = htmlConstants.TERMS_AND_CONDITIONS;
      }
    }
  };
</script>
